import { Children } from 'react';
import { AccordionProps } from '@mui/material/Accordion';
import css from '../Accordion.module.scss';

/**
 * Time it take an accordion to open and close
 * This is an estimation but because we can manually set it
 * To keep transitions and code reliant consistent this is used
 */
export const AccordionDuration = 500;

export const Accordion = ({
    children,
}: AccordionProps) => {
    return (
        <div className={css.accordion}>
            {Children.toArray(children)}
        </div>
    );
};
